export const formatDate = (val) =>
  val
    ? new Date(val).toLocaleDateString("en-US", { timeZone: "UTC" })
    : undefined;
export const formatMoney = (val) =>
  val ? `$${parseFloat(val, 10).toLocaleString()}` : undefined;
export const formatNumber = (val) =>
  val ? `${parseFloat(val, 10).toLocaleString()}` : undefined;
export const formatPercent = (val) =>
  val ? `${(val * 100).toFixed(2)}%` : undefined;
export const formatValue = (val) => (val ? val.toLocaleString() : undefined);
export const formatList = (val) => (val ? val.join(", ") : undefined);
export const urlToDomain = (val) =>
  val ? new URL(val).hostname.replace("www.", "").split(".")[0] : undefined;
export const formatAcres = (val) =>
  val
    ? `${formatNumber(val / 43560)} acres - ${formatNumber(val)} sqft`
    : undefined;
